"use strict";

var XMLDocument = require("../living/generated/XMLDocument.js");
var Document = require("../living/generated/Document.js");
var _require = require("./generated/utils.js"),
  wrapperForImpl = _require.wrapperForImpl;
exports.createImpl = function (globalObject, options) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$alwaysUseDocumen = _ref.alwaysUseDocumentClass,
    alwaysUseDocumentClass = _ref$alwaysUseDocumen === void 0 ? false : _ref$alwaysUseDocumen;
  if (options.parsingMode === "xml" && !alwaysUseDocumentClass) {
    return XMLDocument.createImpl(globalObject, [], {
      options: options
    });
  }
  return Document.createImpl(globalObject, [], {
    options: options
  });
};
exports.createWrapper = function () {
  var _exports;
  return wrapperForImpl((_exports = exports).createImpl.apply(_exports, arguments));
};